import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { getFaqList } from "./services/authService";
import SEO from "./components/SEO";
import MarkdownText from "./components/MarkdownText";

function FAQ() {
  const [faqList, setFaqList] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [search, setSearch] = useState("");

  // API CALL
  useEffect(() => {
    fetchFaq();
  }, []);

  const fetchFaq = async () => {
    try {
      const res = await getFaqList({
        search: "",
        limit: "all",
      });

      if (res.success === "1") {
        setFaqList(res.data.faq_list);
      }
    } catch (err) {
      console.error("FAQ API ERROR:", err);
    }
  };

  // TOGGLE ACCORDION
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // SEARCH FILTER
  const filteredFaq = faqList.filter((item) =>
    item.question.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
    
      <SEO
        title="Frequently Asked Questions | Rolo Transit Help & Support"
        description="Have questions about booking a Rolo cab? Find answers about RoloShield, pricing, outstation trips, driver partnerships, and technical app support here."
        keywords="Rolo FAQ, How to book Rolo cab, RoloShield safety, Rolo driver registration, Rolo customer care Pune."
        url="https://rolotransit.com/faq"
      />

   

      {/* page content */}
      <Navbar />

      <div className="faq-container">
        {/* HEADER */}
        <h1 className="faq-title">
          Frequently
          <br />
          Asked Questions!
        </h1>
        <p className="faq-sub">
          Ask anything you need to know about our services
        </p>

        {/* SEARCH */}
        <input
          type="text"
          placeholder="Search Bar"
          className="faq-search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* FAQ LIST */}
        <div className="faq-box">
          {filteredFaq.map((faq, index) => (
            <div key={index} className="faq-item">
              {/* QUESTION */}
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <span className="faq-icon">
                  {openIndex === index ? (
                    <i className="fas fa-minus"></i>
                  ) : (
                    <i className="fas fa-plus"></i>
                  )}
                </span>
                <span>{faq.question}</span>
              </div>
              {/* ANSWER */}
              {openIndex === index && (
                <div className="faq-answer">  
                 <MarkdownText text={faq.answer_text} />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CONTACT BOX */}
        <div className="faq-contact-wrapper">
  <div className="faq-contact">
    <h4>Have any other questions?</h4>
    <p>Don't hesitate to send us an email with your enquiry at:</p>
    <button><a
  href="mailto:support@rolotransit.com"
  className="fw-light"
  style={{ fontSize: "16px", color: "inherit", textDecoration: "none" }}
>
  support@rolotransit.com
</a></button>
  </div>
</div>

      <Footer />
      </div>


      {/* STYLES */}
      <style>{`
        .faq-container {
          background: #000;
          color: #fff;
          padding: 120px 2%;
          min-height: 100vh;
        }

        .faq-title {
          text-align: center;
          color: #FF7F1F;
        
          font-weight: 800;
          font-family: Inter;

font-style: Extra Bold;
font-size: 70px;

line-height: 121%;
letter-spacing: 0%;
text-align: center;

        }

        .faq-sub {
          text-align: center;
          color: #ccc;
          margin-top: 50px;
          margin-bottom: 100px;
          font-family: Inter;
font-weight: 500;
font-style: Semi Bold;
font-size:28px;

line-height: 121%;
letter-spacing: 0%;
text-align: center;

        }

       .faq-search {
  width: 100%;
  padding: 20px;
  border-radius: 50px; /* 🔥 more rounded */
  border: none;
  background: #FBEFE6;
  margin-bottom: 40px;
}

        .faq-box {
          border: 1px solid #444;
          border-radius: 10px;
          overflow: hidden;
        }

        .faq-item {
          border-bottom: 1px solid #444;
        }

        .faq-question {
  padding: 18px 22px;
  color: #FF7F1F;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  
  align-items: center;
  font-size: 14px;
}


/* ICON */
.faq-icon {
  font-size: 22px;
  font-weight: bold;
  color: #FF7F1F;
  margin-right: 15px;
}

/* ANSWER BOX */
.faq-answer {
  padding: 18px 22px;
  color: #FFFFFF;
 font-weight: 400;
  line-height: 1.6;
  font-size: 13px;
  margin-left: 37px; /* INDENT TO ALIGN WITH QUESTION TEXT */
}

/* BORDER FIX (LIKE IMAGE) */
.faq-item {
  border-bottom: 1px solid #333;
}

/* LAST BORDER RADIUS FIX */
.faq-box {
  border: 1px solid #333;
  border-radius: 10px;
  overflow: hidden;
}
          /* FULL WIDTH STRIP */
.faq-contact-wrapper {

  background: #e5e5e5; /* light grey like image */
  margin-top: 50px;
  padding: 40px 0;

  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  width: 100vw;

}

/* INNER CONTENT (aligned like your page) */
.faq-contact {
  width:100%;
  max-width: 1400px;
  margin: auto;
  
}

/* TEXT STYLING */
.faq-contact h4 {
  color: #C25300;
  margin-bottom: 10px;
  font-family: Inter;
font-weight: 600;
font-style: Semi Bold;
font-size: 20px;
leading-trim: NONE;
line-height: 121%;
letter-spacing: 0%;

}

.faq-contact p {
  color: 
  #000000;
  margin-bottom: 15px;
  font-family: Inter;
font-weight: 500;
font-style: Medium;
font-size: 16px;
leading-trim: NONE;
line-height: 121%;
letter-spacing: 0%;

}

.faq-contact button {
  background: #D25A00;
  color: #F5F5F5;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  
}
  .faq-link {
  color: #FF7F1F;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
}

.faq-link:hover {
  color: #FF9344;
}


        @media(max-width:768px){
          .faq-title {
            font-size: 32px;
          }
        }
      `}</style>
    </>
  );
}

export default FAQ;
